import { setDataMiningOnSessionStorage } from '~~/modules/integrations/datamining/composables/useDataMiningComposable'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on server
  if (import.meta.server) return

  const isAdminRoute = to.matched.some(
    matchedRoute => matchedRoute.meta.AuthAdmin === true,
  )

  if (!isAdminRoute) {
    // Defer analytics setup to not block initial render
    const nuxtApp = useNuxtApp()
    nuxtApp.hook('page:loading:end', () => {
      try {
        setDataMiningOnSessionStorage()
      } catch (error) {
        console.error('Analytics setup failed:', error)
      }
    })
  }
  return
})
